// import {useState, useRef} from 'react';
import {Row,Col, Dropdown} from 'react-bootstrap';
import {useState, useEffect} from 'react'

function DashboardUserButton({userFullname = '', changeView }) {

    const logout = () => {
        localStorage.removeItem('access')
        localStorage.removeItem('refresh')
        setTimeout(()=>{window.location.assign('/login')},300)
    }

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    
    useEffect(() => {
      const updateWindowDimensions = () => {
        const newWidth = window.innerWidth;
        setWindowWidth(newWidth);
      };
      window.addEventListener("resize", updateWindowDimensions);
      return () => window.removeEventListener("resize", updateWindowDimensions) 
    }, []);

    const goToProfile = () => {
        changeView('profile-form')
    }

    return (
        <Dropdown>
            <Dropdown.Toggle id="dashboard-user-button-toggle" className='bg-gray'>
                <i className="mdi mdi-account-circle text-16 fg-orange me-2"></i>
                {windowWidth>600 ? <span>{userFullname}</span> : ''}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item href="#" className="py-2" onClick={goToProfile}>Profile</Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item href="#" className="py-2" onClick={logout}><i className="mdi mdi-logout me-2"></i>Logout</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default DashboardUserButton